// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
interface IconHeaderProps extends ReactProps {
    iconUrl: string;
    iconAtt?: any;
    title: string;
    rcClass?: string;
    lcClass?: string;
    onClick?: any;
    btnUrl?: any;
    btnAtt?: any;
    btnUrls?: IconHeaderButton[];
}

interface IconHeaderButton {
    onClick: any;
    btnUrl: string;
    btnAtt: any;
    id?: string;
}

const IconHeader = (props: IconHeaderProps) => (
    <div className="container ih-container">
        <div className="col-md-8">
            <div className={`ih-l-content ${props.lcClass ? props.lcClass : ""}`}>
                <img src={props.iconUrl} {...props.iconAtt} />
                <p className="titleName">{props.title}</p>
            </div>
        </div>
        <div className={`col-md-4 ih-r-content ${props.rcClass ? props.rcClass : ""}`}>
            {props.btnUrl
                ? <a onClick={props.onClick}><img className="img-responsive" src={props.btnUrl} {...props.btnAtt} /></a>
                : ""
            } 
            {
                props.btnUrls ?
                    props.btnUrls.map((btn: any, index: number) => {
                        return <a key={index} id={btn.id} onClick={btn.onClick}><img className="img-responsive" src={btn.btnUrl} {...btn.btnAtt} /></a>;
                    })
                    : ""
            }
        </div>
    </div>
);

export default IconHeader;